import { Union, Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { uint8_type, int32_type, bool_type, union_type, unit_type, list_type, class_type, obj_type, record_type, option_type, string_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { tryFind } from "../../fable_modules/fable-library.3.7.20/List.js";
import { FSharpResult$2 } from "../../fable_modules/fable-library.3.7.20/Choice.js";
import { printf, toFail } from "../../fable_modules/fable-library.3.7.20/String.js";
import { DateTimeExtensions_toIso8601 } from "../../Utils.js";
import { LoadState$2$reflection, GlobalDependencies$reflection, SaveStatus$reflection } from "../../Global.js";
import { ContractType$reflection, Contract$reflection } from "../Invoicee/Common.js";
import { Sim$reflection, NumberHistory$reflection } from "../Subscriptions/Common.js";
import { map, bind } from "../../fable_modules/fable-library.3.7.20/Option.js";
import { tryFind as tryFind_1 } from "../../fable_modules/fable-library.3.7.20/Map.js";

export class NumberRegisterModificationDTO extends Record {
    constructor(NewFromDate, NewToDate, OriginalFromDate) {
        super();
        this.NewFromDate = NewFromDate;
        this.NewToDate = NewToDate;
        this.OriginalFromDate = OriginalFromDate;
    }
}

export function NumberRegisterModificationDTO$reflection() {
    return record_type("Containers.Telecom.Model.NumberRegisterModificationDTO", [], NumberRegisterModificationDTO, () => [["NewFromDate", string_type], ["NewToDate", option_type(string_type)], ["OriginalFromDate", string_type]]);
}

export function getSelectedNumberHistory(indexOpt, numberHistoriesLoadState) {
    const matchValue = [indexOpt, numberHistoriesLoadState];
    let pattern_matching_result, index, numberHistories;
    if (matchValue[0] != null) {
        if (matchValue[1].tag === 2) {
            pattern_matching_result = 0;
            index = matchValue[0];
            numberHistories = matchValue[1].fields[0];
        }
        else {
            pattern_matching_result = 1;
        }
    }
    else {
        pattern_matching_result = 1;
    }
    switch (pattern_matching_result) {
        case 0: {
            const matchValue_1 = tryFind((nh) => (nh.Index === index), numberHistories);
            if (matchValue_1 != null) {
                return matchValue_1;
            }
            else {
                return void 0;
            }
        }
        case 1: {
            return void 0;
        }
    }
}

export class EventDTO extends Record {
    constructor(argument, type) {
        super();
        this.argument = argument;
        this.type = type;
    }
}

export function EventDTO$reflection() {
    return record_type("Containers.Telecom.Model.EventDTO", [], EventDTO, () => [["argument", obj_type], ["type", string_type]]);
}

export class EventsDTO extends Record {
    constructor(at, event) {
        super();
        this.at = at;
        this.event = event;
    }
}

export function EventsDTO$reflection() {
    return record_type("Containers.Telecom.Model.EventsDTO", [], EventsDTO, () => [["at", class_type("System.DateTimeOffset")], ["event", EventDTO$reflection()]]);
}

export class PendingProvisioningEventsDTO extends Record {
    constructor(number, events) {
        super();
        this.number = number;
        this.events = events;
    }
}

export function PendingProvisioningEventsDTO$reflection() {
    return record_type("Containers.Telecom.Model.PendingProvisioningEventsDTO", [], PendingProvisioningEventsDTO, () => [["number", string_type], ["events", list_type(EventsDTO$reflection())]]);
}

export class SaveActiveNumberDto extends Record {
    constructor(fromDate, toDate, iccOrImsi) {
        super();
        this.fromDate = fromDate;
        this.toDate = toDate;
        this.iccOrImsi = iccOrImsi;
    }
}

export function SaveActiveNumberDto$reflection() {
    return record_type("Containers.Telecom.Model.SaveActiveNumberDto", [], SaveActiveNumberDto, () => [["fromDate", string_type], ["toDate", option_type(string_type)], ["iccOrImsi", option_type(string_type)]]);
}

export class CreatePortationEvent extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["SaveCreateInportation", "SavedCreateInportation", "ClearErrorMessage"];
    }
}

export function CreatePortationEvent$reflection() {
    return union_type("Containers.Telecom.Model.CreatePortationEvent", [], CreatePortationEvent, () => [[["Number", string_type], ["OrgNr", option_type(string_type)], ["Date", class_type("System.DateTime")]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, string_type], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", string_type]]])]], []]);
}

export class NumberChoice extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["ExistingNumber", "NewNumber"];
    }
}

export function NumberChoice$reflection() {
    return union_type("Containers.Telecom.Model.NumberChoice", [], NumberChoice, () => [[], []]);
}

const NumberChoiceModule_existingNumber = "ExistingNumber";

const NumberChoiceModule_newNumber = "NewNumber";

export function NumberChoiceModule_toString(_arg) {
    if (_arg.tag === 1) {
        return NumberChoiceModule_newNumber;
    }
    else {
        return NumberChoiceModule_existingNumber;
    }
}

export function NumberChoiceModule_ofString(_arg) {
    switch (_arg) {
        case NumberChoiceModule_existingNumber: {
            return new NumberChoice(0);
        }
        case NumberChoiceModule_newNumber: {
            return new NumberChoice(1);
        }
        default: {
            return toFail(printf("Could not parse string \u0027%s\u0027 to NumberChoice."))(_arg);
        }
    }
}

export function NumberChoiceModule_toTranslation(getTranslation, _arg) {
    if (_arg.tag === 1) {
        return getTranslation("CustomerContract.Invoicee.Subscriptions.Telecom.NewNumber");
    }
    else {
        return getTranslation("CustomerContract.Invoicee.Subscriptions.Telecom.InportationNumber");
    }
}

export class AvailableNumber extends Record {
    constructor(NumberFrom, NumberTo) {
        super();
        this.NumberFrom = NumberFrom;
        this.NumberTo = NumberTo;
    }
}

export function AvailableNumber$reflection() {
    return record_type("Containers.Telecom.Model.AvailableNumber", [], AvailableNumber, () => [["NumberFrom", string_type], ["NumberTo", string_type]]);
}

export class ItemDTO extends Record {
    constructor(Portation) {
        super();
        this.Portation = Portation;
    }
}

export function ItemDTO$reflection() {
    return record_type("Containers.Telecom.Model.ItemDTO", [], ItemDTO, () => [["Portation", bool_type]]);
}

export class CreateActivationDTO extends Record {
    constructor(AtUtcDate, Item) {
        super();
        this.AtUtcDate = AtUtcDate;
        this.Item = Item;
    }
}

export function CreateActivationDTO$reflection() {
    return record_type("Containers.Telecom.Model.CreateActivationDTO", [], CreateActivationDTO, () => [["AtUtcDate", string_type], ["Item", ItemDTO$reflection()]]);
}

export class PortationRequestDTO extends Record {
    constructor(contract_nr, number, organization_number, porting_time) {
        super();
        this.contract_nr = (contract_nr | 0);
        this.number = number;
        this.organization_number = organization_number;
        this.porting_time = porting_time;
    }
}

export function PortationRequestDTO$reflection() {
    return record_type("Containers.Telecom.Model.PortationRequestDTO", [], PortationRequestDTO, () => [["contract_nr", int32_type], ["number", string_type], ["organization_number", option_type(string_type)], ["porting_time", string_type]]);
}

export function getPortationRequestDTO(contractNr, number, orgNrOpt, date) {
    return new PortationRequestDTO(contractNr, number, orgNrOpt, DateTimeExtensions_toIso8601(date));
}

export class TrafficRedirect extends Record {
    constructor(ClientNr, NetworkContractNr, FromNumber, FromDate, ToDate, ToNumber, Imsi, TypeOf, SimType, ExchangeId, HideOnInvoice) {
        super();
        this.ClientNr = ClientNr;
        this.NetworkContractNr = NetworkContractNr;
        this.FromNumber = FromNumber;
        this.FromDate = FromDate;
        this.ToDate = ToDate;
        this.ToNumber = ToNumber;
        this.Imsi = Imsi;
        this.TypeOf = TypeOf;
        this.SimType = SimType;
        this.ExchangeId = ExchangeId;
        this.HideOnInvoice = HideOnInvoice;
    }
}

export function TrafficRedirect$reflection() {
    return record_type("Containers.Telecom.Model.TrafficRedirect", [], TrafficRedirect, () => [["ClientNr", class_type("System.Decimal")], ["NetworkContractNr", uint8_type], ["FromNumber", string_type], ["FromDate", class_type("System.DateTimeOffset")], ["ToDate", option_type(class_type("System.DateTimeOffset"))], ["ToNumber", string_type], ["Imsi", option_type(class_type("System.Decimal"))], ["TypeOf", string_type], ["SimType", string_type], ["ExchangeId", option_type(string_type)], ["HideOnInvoice", bool_type]]);
}

export class OrderDTO extends Record {
    constructor(CancelledDate, Date$, ErrorDate, ErrorString, IsAdd, Operation, OrderNr, Parameters, SuccessDate, Number$, CreatedBy) {
        super();
        this.CancelledDate = CancelledDate;
        this.Date = Date$;
        this.ErrorDate = ErrorDate;
        this.ErrorString = ErrorString;
        this.IsAdd = IsAdd;
        this.Operation = Operation;
        this.OrderNr = (OrderNr | 0);
        this.Parameters = Parameters;
        this.SuccessDate = SuccessDate;
        this.Number = Number$;
        this.CreatedBy = CreatedBy;
    }
}

export function OrderDTO$reflection() {
    return record_type("Containers.Telecom.Model.OrderDTO", [], OrderDTO, () => [["CancelledDate", option_type(class_type("System.DateTime"))], ["Date", class_type("System.DateTime")], ["ErrorDate", option_type(class_type("System.DateTime"))], ["ErrorString", option_type(string_type)], ["IsAdd", bool_type], ["Operation", string_type], ["OrderNr", int32_type], ["Parameters", string_type], ["SuccessDate", option_type(class_type("System.DateTime"))], ["Number", string_type], ["CreatedBy", option_type(string_type)]]);
}

export class DetailDTO extends Record {
    constructor(category, description, name, value) {
        super();
        this.category = category;
        this.description = description;
        this.name = name;
        this.value = value;
    }
}

export function DetailDTO$reflection() {
    return record_type("Containers.Telecom.Model.DetailDTO", [], DetailDTO, () => [["category", string_type], ["description", string_type], ["name", string_type], ["value", string_type]]);
}

export class NetworkDetails extends Record {
    constructor(Description, Name, Value) {
        super();
        this.Description = Description;
        this.Name = Name;
        this.Value = Value;
    }
}

export function NetworkDetails$reflection() {
    return record_type("Containers.Telecom.Model.NetworkDetails", [], NetworkDetails, () => [["Description", string_type], ["Name", string_type], ["Value", string_type]]);
}

export class DeactivateNumberModal extends Record {
    constructor(SaveStatus) {
        super();
        this.SaveStatus = SaveStatus;
    }
}

export function DeactivateNumberModal$reflection() {
    return record_type("Containers.Telecom.Model.DeactivateNumberModal", [], DeactivateNumberModal, () => [["SaveStatus", SaveStatus$reflection()]]);
}

export class Telecom extends Record {
    constructor(ContractNr, GlobalDependencies, Contracts, ContractTypes, NumberHistory, SelectedNumberHistoryIndex, Sim, TrafficRedirects, CreatePortationSaveStatus, ShowMoreInfo, DeactivateNumberModal, NumberRegisterModificationSaveStatus, NetworkIntegrationNr) {
        super();
        this.ContractNr = (ContractNr | 0);
        this.GlobalDependencies = GlobalDependencies;
        this.Contracts = Contracts;
        this.ContractTypes = ContractTypes;
        this.NumberHistory = NumberHistory;
        this.SelectedNumberHistoryIndex = SelectedNumberHistoryIndex;
        this.Sim = Sim;
        this.TrafficRedirects = TrafficRedirects;
        this.CreatePortationSaveStatus = CreatePortationSaveStatus;
        this.ShowMoreInfo = ShowMoreInfo;
        this.DeactivateNumberModal = DeactivateNumberModal;
        this.NumberRegisterModificationSaveStatus = NumberRegisterModificationSaveStatus;
        this.NetworkIntegrationNr = NetworkIntegrationNr;
    }
}

export function Telecom$reflection() {
    return record_type("Containers.Telecom.Model.Telecom", [], Telecom, () => [["ContractNr", int32_type], ["GlobalDependencies", GlobalDependencies$reflection()], ["Contracts", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [int32_type, Contract$reflection()])], ["ContractTypes", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, ContractType$reflection()])], ["NumberHistory", LoadState$2$reflection(list_type(NumberHistory$reflection()), string_type)], ["SelectedNumberHistoryIndex", option_type(int32_type)], ["Sim", LoadState$2$reflection(option_type(Sim$reflection()), string_type)], ["TrafficRedirects", LoadState$2$reflection(list_type(TrafficRedirect$reflection()), string_type)], ["CreatePortationSaveStatus", SaveStatus$reflection()], ["ShowMoreInfo", bool_type], ["DeactivateNumberModal", DeactivateNumberModal$reflection()], ["NumberRegisterModificationSaveStatus", SaveStatus$reflection()], ["NetworkIntegrationNr", LoadState$2$reflection(option_type(int32_type), string_type)]]);
}

export function getNetworkContractNr(contractNr, contracts, contractTypes) {
    return bind((contractType) => contractType.NetworkContractNr, bind((code) => tryFind_1(code, contractTypes), map((contract) => contract.ContractTypeCode, tryFind_1(contractNr, contracts))));
}

